import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowSwitchHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 9.6 2.4 6m0 0L6 2.4M2.4 6h19.2M18 14.4l3.6 3.6m0 0L18 21.6m3.6-3.6H2.4"
    />
  </svg>
);
export default SvgArrowSwitchHorizontal;
